import { Injectable } from '@angular/core';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentsMenuService {

  constructor(private utils: UtilsService) { }

  getSubMenuItems(): any[] {
    const subMenuItems: any[] = [];

    subMenuItems.push({
      icon: 'assets/icons/icon_cash.png',
      title: 'CAJA',
      route: '/panel/payments',
    });

    subMenuItems.push({
      icon: 'assets/icons/icon_cash_closing.png',
      title: 'CERRAR CAJA',
      route: '/panel/payments/cashclose',
    });

    if (this.utils.validatePermission('see_cash_register')) {
      subMenuItems.push({
        icon: 'assets/icons/icon_cash_closing.png',
        title: 'REGISTRO DE CAJAS',
        route: '/panel/payments/cash-register',
      });
    }

    subMenuItems.push({
      icon: 'assets/icons/icon_list.png',
      title: 'LISTA DE TICKETS',
      route: '/panel/payments/summary',
    });

    if (this.utils.validatePermission('see_invoices')) {
      subMenuItems.push({
        icon: 'assets/icons/icon_list.png',
        title: 'LISTA DE FACTURAS',
        route: '/panel/payments/invoices',
      });
    }

    if (this.utils.validatePermission('create_proform')) {
      subMenuItems.push({
        icon: 'assets/icons/icon_list.png',
        title: 'LISTA DE PROFORMAS',
        route: '/panel/payments/proformas',
      });
    }
    if (this.utils.validatePermission('create_invoice')) {
      subMenuItems.push({
        icon: 'assets/icons/icon_print.png',
        title: 'CREAR FACTURA',
        route: '/panel/payments/invoices/create',
      });
    }

    return subMenuItems;
  }
}
